<template>
    <div>
        <div class="header__submenu">
            <div class="container">
                <div class="row flex-row">
                    <div v-if="!$device.isDesktop" class="col lg-1 md-2 sm-12 col--padding-left">
                        <div>
                            <svg-icon
                                class="header__submenu-back"
                                name="arrow-left--18"
                                width="18"
                                height="18"
                                @click="$emit('back')"></svg-icon>
                            <component
                                :is="url ? 'nuxt-link' : 'div'"
                                :to="url || null"
                                class="text_15 text_bold submenu-list__mobile-title"
                                @click.native="$emit('close')">
                                {{ title }}
                                <svg-icon v-if="url" name="arrow-right--16" width="16" height="16"></svg-icon>
                            </component>
                        </div>
                    </div>
                    <div class="col lg-12">
                        <div class="flex submenu-list-container text_13">
                            <div class="submenu-list">
                                <div class="submenu-list__top">
                                    <nuxt-link
                                        v-for="(topLink, index) in top"
                                        :key="`top-${index}`"
                                        :to="topLink.url"
                                        :style="`color:${topLink.highlight || '#000'}`"
                                        class="submenu-list__item"
                                        :class="{ 'submenu-list__item--active': topLink.title === currentParentTitle }"
                                        @click.native="onLinkClick($event, topLink)">
                                        <span @mouseenter="showChilds(topLink, 'replace-right')">
                                            {{ topLink.title }}
                                            <svg-icon
                                                v-if="topLink.children"
                                                name="arrow-right--16"
                                                width="16"
                                                height="16"></svg-icon>
                                        </span>
                                    </nuxt-link>
                                </div>
                                <div class="submenu-list__bottom">
                                    <nuxt-link
                                        v-for="(bottomLink, index) in bottom"
                                        :key="`bottom-${index}`"
                                        :to="bottomLink.url"
                                        :style="`color:${bottomLink.highlight || '#000'}`"
                                        class="submenu-list__item"
                                        :class="{
                                            'submenu-list__item--active':
                                                bottomLink.title === currentParentTitle ||
                                                $route.path === bottomLink.url,
                                        }"
                                        @click.native="onLinkClick($event, bottomLink)">
                                        <span @mouseenter="showChilds(bottomLink, 'replace-right')">
                                            {{ bottomLink.title }}
                                            <svg-icon
                                                v-if="bottomLink.children"
                                                name="arrow-right--16"
                                                width="16"
                                                height="16"></svg-icon>
                                        </span>
                                    </nuxt-link>
                                </div>
                            </div>
                            <div class="submenu-lists">
                                <component :is="$device.isMobile ? 'div' : 'transition'" class="flex" name="fade">
                                    <div
                                        v-if="currentChildsType !== 'replace-right'"
                                        class="submenu-list submenu-list--categories"
                                        key="categories">
                                        <div class="submenu-list__top">
                                            <nuxt-link
                                                v-for="(rightLink, index) in right"
                                                :to="rightLink.url"
                                                :key="`cat-${index}`"
                                                :style="`color:${rightLink.highlight || '#000'}`"
                                                class="submenu-list__item"
                                                :class="{
                                                    'submenu-list__item--active':
                                                        rightLink.title === currentParentTitle ||
                                                        $route.path === rightLink.url,
                                                }"
                                                @click.native="onLinkClick($event, rightLink)">
                                                <span @mouseenter="showChilds(rightLink)"
                                                    >{{ rightLink.title
                                                    }}<svg-icon
                                                        v-if="rightLink.children"
                                                        name="arrow-right--16"
                                                        width="16"
                                                        height="16"></svg-icon
                                                ></span>
                                            </nuxt-link>
                                        </div>
                                    </div>
                                </component>
                                <component
                                    :is="$device.isMobile ? 'div' : 'transition'"
                                    class="flex"
                                    name="fade"
                                    mode="out-in">
                                    <div v-if="currentChilds" class="submenu-list" key="categories-childs">
                                        <div class="submenu-list__top">
                                            <nuxt-link
                                                v-for="(childLink, index) in currentChilds"
                                                :to="childLink.url"
                                                :key="`cat-${index}`"
                                                :style="`color:${childLink.highlight || '#000'}`"
                                                class="submenu-list__item"
                                                :class="{
                                                    'submenu-list__item--active': $route.path === childLink.url,
                                                }"
                                                @click.native="$emit('close')">
                                                <span>{{ childLink.title }}</span>
                                            </nuxt-link>
                                        </div>
                                    </div>
                                </component>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="submenu-dimmer" @mouseenter="$emit('close')" v-if="$device.isDesktop"></div>
    </div>
</template>
<script>
export default {
    name: "HeaderDropDownCategoriesByGender",
    props: {
        title: {
            type: String,
            required: true,
        },
        top: {
            type: Array,
            required: true,
        },
        bottom: {
            type: Array,
            required: true,
        },
        right: {
            type: Array,
            required: true,
        },
        url: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            currentChildsType: "",
            currentChilds: null,
            currentParentTitle: "",
        };
    },
    methods: {
        onLinkClick(event, item) {
            if (this.$device.isDesktop || !item.children) {
                this.$emit("close");
            } else {
                event.preventDefault();
                this.$emit("update:isShowCategories", {
                    ...item,
                    children: { right: item.children, top: null, bottom: null },
                });
            }
        },
        showChilds(item, type = "") {
            if (this.$device.isDesktop) {
                this.currentChilds = item.children;
                this.currentChildsType = item.children ? type : "";
                this.currentParentTitle = item.title;
            }
        },
    },
};
</script>
<style lang="less">
.submenu-list-container {
    gap: 63px;
    @media @sm {
        flex-direction: column;
        gap: 0;
        padding-left: 0;
    }
}
.header__submenu {
    position: absolute;
    left: 0;
    right: 0;
    top: 100%;
    display: flex;
    flex-direction: column;
    background: @bg;
    z-index: 7;
    min-height: 382px;
    @media @sm {
        margin: 0;
        padding: 0;
        padding-top: 6px;
        top: 0px;
    }
    @media @notsm {
        border-top: 1px solid @border2;
        border-bottom: 1px solid @border2;
    }
    &-back {
        margin: 15px 0;
    }
}

.submenu-dimmer {
    position: fixed;
    background: #f2f1e9;
    opacity: 0.7;
    top: 37px;
    bottom: 0;
    left: 0;
    right: 0;
    .has-promo-header & {
        top: 77px;
    }
}

.submenu-list {
    display: flex;
    flex-direction: column;
    padding: 32px 0;
    width: 271px;
    max-width: 100%;
    box-sizing: content-box;
    // .nuxt-link-exact-active {
    //     color: @purple;
    // }
    &:first-child.fade-enter-active {
        position: absolute;
        transition-delay: 0.3s;
    }
    &.fade-leave-active + .submenu-list {
        transition-delay: 0.3s;
    }
    &--categories {
        width: 342px;
    }

    &__bottom,
    &__top {
        display: flex;
        flex-direction: column;
        gap: 4px;
        &:empty {
            display: none;
        }
        @media @sm {
            gap: 16px;
            padding: 16px 0;
        }
    }
    &__top {
        padding: 6px 0 16px;
        @media @sm {
            gap: 24px;
        }
    }
    &__bottom {
        margin-top: auto;
    }
    @media @sm {
        margin-top: 0;
        padding: 0;
        width: 100%;
        & + & {
            padding-left: 20px;
        }
    }
    &__mobile-title {
        color: @red2;
        display: flex;
        justify-content: space-between;
        gap: 8px;
        align-items: center;
        margin-bottom: 22px;
        padding-right: 16px;
    }
    &__title {
        margin-bottom: 25px;
    }

    &__item {
        padding: 6px 0;
        break-inside: avoid;

        @media @sm {
            margin-bottom: 0;
            padding: 0;
        }
        span {
            position: relative;
            display: inline-flex;
            align-items: center;
            gap: 4px;
        }
        &--active {
            color: @red2 !important;
        }
    }
}
.submenu-lists {
    display: flex;
    gap: 44px;
    @media @sm {
        width: 100%;
    }
    > .flex {
        width: 100%;
    }
}
</style>
